import { render, staticRenderFns } from "./SocialLinks.vue?vue&type=template&id=0617f268"
import script from "./SocialLinks.vue?vue&type=script&lang=ts"
export * from "./SocialLinks.vue?vue&type=script&lang=ts"
import style0 from "./SocialLinks.vue?vue&type=style&index=0&id=0617f268&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports